import { cn } from '@/lib/utils';

/**
 * AdminTableSkeleton — 通用表格列表骨架屏
 * 适用于：Agents、Users、Staff、Sessions、Withdrawals、Audit、Proposals
 */
export default function AdminTableSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <div className="space-y-6">
      {/* 标题 + 新增按钮 */}
      <div className="flex items-center justify-between">
        <div className="h-7 w-40 bg-surface-2 rounded-md animate-pulse" />
        <div className="h-9 w-28 bg-surface-2 rounded-lg animate-pulse" />
      </div>

      {/* 搜索 + 筛选 */}
      <div className="flex flex-col sm:flex-row gap-3">
        <div className="flex-1 h-10 bg-surface-2 rounded-lg animate-pulse" />
        <div className="h-10 w-full sm:w-44 bg-surface-2 rounded-lg animate-pulse" />
        <div className="h-10 w-full sm:w-44 bg-surface-2 rounded-lg animate-pulse" />
      </div>

      {/* 表格行 */}
      <div className="space-y-3">
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="flex items-center gap-4 p-4 bg-surface-1 rounded-lg">
            {/* 头像/图标占位 */}
            <div className="h-10 w-10 rounded-full bg-surface-2 animate-pulse shrink-0" />
            <div className="flex-1 min-w-0 space-y-2">
              <div className="h-4 w-3/4 bg-surface-2 rounded animate-pulse" />
              <div className="h-3 w-1/2 bg-surface-2 rounded animate-pulse" />
            </div>
            {/* 状态 Badge 占位 */}
            <div className="h-6 w-16 bg-surface-2 rounded-full animate-pulse shrink-0" />
            {/* 操作按钮占位 */}
            <div className="h-8 w-20 bg-surface-2 rounded-lg animate-pulse shrink-0" />
          </div>
        ))}
      </div>

      {/* 分页 */}
      <div className="flex justify-center gap-2 pt-4">
        {[1, 2, 3, 4, 5].map(i => (
          <div key={i} className="h-8 w-8 bg-surface-2 rounded animate-pulse" />
        ))}
      </div>
    </div>
  );
}
